import customEngagementButtonTpl from '../templates/dsp/custom_engagement_button.directive.html';

function CustomEngagementButtonController(CreativeService) {
  var vm = this;

  vm.creativeService = CreativeService;

  return vm;
}

CustomEngagementButtonController.$inject = ['CreativeService'];

export default function customEngagementButton() {
  return {
    template: customEngagementButtonTpl,
    controller: CustomEngagementButtonController,
    controllerAs: 'customButtonVm'
  };
}
